import { z } from 'zod'
import errorMap from '@gap/backend/util/validations/validation-error-map'

export namespace UserTrialDataDto {
   export const situations = ['starting', 'improving', 'scaling'] as const
   export const situationText = {
      starting: 'I’m new to advisory and am looking for the best way to get started',
      improving: 'I already do some advisory and am looking for ways to improve',
      scaling: 'I already do advisory and am looking to scale our advisory offering across my team',
   } satisfies Record<(typeof situations)[number], string>
   export const situationEnumSchema = z.enum(situations, { errorMap })

   export const barriers = ['getting-started', 'knowledge', 'positioning', 'time', 'structure', 'client-relations'] as const
   export const barriersText = {
      'getting-started': { title: 'Getting started', description: 'I don’t know where to begin.' },
      knowledge: { title: 'Knowledge', description: 'I don’t know enough to deliver advisory services confidently.' },
      positioning: { title: 'Positioning', description: 'I’m worried clients won’t see me as an advisor.' },
      time: { title: 'Time', description: 'I’m too busy in the weeds of compliance work.' },
      structure: { title: 'Structure', description: 'I don’t have enough structure to my processes.' },
      'client-relations': { title: 'Client relations', description: 'I don’t know which clients to approach or how to go about it.' },
   } satisfies Record<(typeof barriers)[number], { title: string; description: string }>
   export const barriersEnumSchema = z.enum(barriers, { errorMap })

   export const createSchema = z.object({
      planning: z.string({ errorMap }).optional(),
      experience: z.string({ errorMap }).optional(),
      expectations: z.array(z.string({ errorMap })).optional(),
      situation: z.string({ errorMap }).optional(),
      barriers: z.array(z.string({ errorMap })).optional(),
   })

   export const updateSchema = z.object({
      planning: z.string({ errorMap }).optional(),
      experience: z.string({ errorMap }).optional(),
      expectations: z.array(z.string({ errorMap })).optional(),
      situation: situationEnumSchema,
      barriers: z.array(barriersEnumSchema),
   })

   export type Update = z.output<typeof updateSchema>
}
